import Users from 'src/api/users.js'

const defaultState = () => ({
  unreadNotifications: 0,
  personalNotificationChatId: null,
  personalNotificationChannelId: null
})

export const state = defaultState()

export const mutations = {
  RESET_STATE (state) {
    Object.assign(state, defaultState())
  },
  SET_UNREAD_NOTIFICATION_COUNTER (state, unreadNotificationsCount) {
    state.unreadNotifications = unreadNotificationsCount
  },
  SET_PERSONAL_NOTIFICATION_CHAT_ID (state, chatId) {
    state.personalNotificationChatId = chatId
  },
  SET_PERSONAL_NOTIFICATION_CHANNEL_ID (state, channelId) {
    state.personalNotificationChannelId = channelId
  }
}

export const getters = {
  UNREAD_NOTIFICATION_COUNTER (state) {
    return state.unreadNotifications
  },
  PERSONAL_NOTIFICATION_CHAT_ID (state) {
    return state.personalNotificationChatId
  },
  PERSONAL_NOTIFICATION_CHANNEL_ID (state) {
    return state.personalNotificationChannelId
  }
}

export const actions = {
  async setPersonalNotificationChannelChatId ({ commit }) {
    // Fetch the personal-notifications channel which connects all created notifications
    const { data } = await Users.getPersonalNotifications()
    commit('SET_PERSONAL_NOTIFICATION_CHAT_ID', data?.chat_id)
    commit('SET_PERSONAL_NOTIFICATION_CHANNEL_ID', data?.id)
  },
  async updateUnreadNotificationCount ({ commit }, unreadCount) {
    commit('SET_UNREAD_NOTIFICATION_COUNTER', unreadCount || 0)
  }
}
